import { render, staticRenderFns } from "./PublishingTier.vue?vue&type=template&id=ffa8faf2&scoped=true&"
import script from "./PublishingTier.vue?vue&type=script&lang=js&"
export * from "./PublishingTier.vue?vue&type=script&lang=js&"
import style0 from "./PublishingTier.vue?vue&type=style&index=0&id=ffa8faf2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa8faf2",
  null
  
)

export default component.exports